/**
 * Medan Email dalam popup pelanggan Flow Ultra (2026-09-28, keputusan user).
 *
 * - Penyewa MANUAL (flow_tenants): boleh diisi/diubah + Save. Tujuannya supaya
 *   Session Access boleh mengaitkan penyewa ini dengan akaun SESAAT melalui
 *   email (loadFlowSubscriptions + searchFlowCustomers padan ikut email).
 * - Pembeli Billplz (flow_subs): baca sahaja — email = kunci rekod bayaran,
 *   dan flow_subs tidak boleh ditulis client.
 */
import { useState } from 'react';
import { Btn } from '../design/ui';
import { kemasLangganan } from '../services/flowLanggananService';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function FlowCustomerEmailField({ customer, onSaved }) {
    const asal = customer.email || '';
    const [nilai, setNilai] = useState(asal);
    const [sedang, setSedang] = useState(false);
    const [ralat, setRalat] = useState('');
    const [disimpan, setDisimpan] = useState(asal);

    if (!customer.manual) {
        return (
            <div>
                <p className="s-kv__lab">Email</p>
                <div className="s-kv__box">{asal || <span className="s-dim">—</span>}</div>
            </div>
        );
    }

    const bersih = nilai.trim().toLowerCase();
    const berubah = bersih !== disimpan;

    const simpan = async () => {
        setRalat('');
        if (bersih && (bersih.length > 254 || !EMAIL_RE.test(bersih))) {
            setRalat('That does not look like a valid email.');
            return;
        }
        setSedang(true);
        try {
            // Fasa 3A: melalui server (flow_subs tidak boleh ditulis client) — uid akaun dicari semula di sana.
            await kemasLangganan(customer, { email: bersih });
            setDisimpan(bersih);
            setNilai(bersih);
            onSaved?.(bersih);
        } catch (e) {
            setRalat(e?.code === 'functions/not-found'
                ? 'Not saved — the server update is not deployed yet.'
                : `Not saved: ${e?.message || 'unknown error'}`);
        } finally {
            setSedang(false);
        }
    };

    return (
        <div>
            <p className="s-kv__lab">Email</p>
            <div style={{ display: 'flex', gap: 8 }}>
                <input className="s-inp" inputMode="email" placeholder="customer@gmail.com" maxLength={254}
                    style={{ flex: 1, minWidth: 0 }}
                    value={nilai} onChange={(e) => setNilai(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter' && berubah && !sedang) simpan(); }} />
                <Btn size="sm" onClick={simpan} disabled={!berubah || sedang}>
                    {sedang ? 'Saving…' : 'Save'}
                </Btn>
            </div>
            {ralat
                ? <p style={{ color: 'var(--s-stop)', fontSize: 13, margin: '6px 0 0' }}>{ralat}</p>
                : <p className="s-kv__hint">The email they use to sign in to SESAAT — lets Session Access find them.</p>}
        </div>
    );
}
